var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m183.319 66.679h301.866c8.729 0 15.815 7.087 15.815 15.815v402.69c0 8.729-7.087 15.816-15.816 15.816h-301.866c-8.729 0-15.815-7.087-15.815-15.815v-402.69c0-8.729 7.087-15.816 15.816-15.816z",
    fill: "#8a96bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.503 485.185v-320.487c0-6.805 2.426-12.661 7.237-17.472l73.31-73.309c4.812-4.812 10.668-7.237 17.472-7.237h219.662c5.508 0 10 4.492 10 10v406.505c0 6.609-5.391 12-12 12h-305.681c-5.506 0-10-4.492-10-10z",
    fill: "#a8b4db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.824 429.506v-320.487c0-6.805 2.426-12.661 7.237-17.472l73.31-73.31c4.811-4.812 10.668-7.237 17.472-7.237h219.662c8.711 0 15.816 7.105 15.816 15.815v402.691c0 8.711-7.105 15.815-15.816 15.815h-301.866c-8.711 0-15.816-7.104-15.816-15.815z",
    fill: "#8a96bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.824 429.506v-320.487c0-6.805 2.426-12.661 7.237-17.472l73.31-73.31c4.812-4.811 10.668-7.237 17.472-7.237h219.662c5.508 0 10 4.492 10 10v406.506c0 6.609-5.391 12-12 12h-305.681c-5.506 0-10-4.492-10-10z",
    fill: "#d2dbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.371 18.237c4.811-4.812 10.668-7.237 17.472-7.237h6.272c-8.99 3.709-15.359 12.579-15.359 22.867v50.254c0 8.709-7.103 15.813-15.812 15.813h-50.254c-10.286 0-19.158 6.369-22.867 15.359v-6.272c0-6.805 2.426-12.661 7.237-17.472z",
    fill: "#8a96bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.371 18.237c4.811-4.812 10.668-7.237 17.472-7.237h6.272c-7.646 1.416-20.757 8.732-20.757 22.867v50.254c0 5.73-4.684 10.415-10.414 10.415h-50.254c-6.807 0-18.704 2.786-22.867 20.757v-6.272c0-6.805 2.426-12.661 7.237-17.472z",
    fill: "#a8b4db"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.815 231.711h347.011c8.729 0 15.816 7.087 15.816 15.816v126.299c0 8.729-7.087 15.816-15.816 15.816h-347.011c-8.729 0-15.815-7.086-15.815-15.815v-126.3c0-8.729 7.087-15.815 15.815-15.815z",
    fill: "#ba0404"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.465 377.631c-.303-1.219-.465-2.493-.465-3.804v-126.299c0-8.711 7.104-15.816 15.815-15.816h340.815c5.508 0 10 4.492 10 10v123.919c0 6.608-5.392 12-12 12z",
    fill: "#ed2f2f",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m312.714 274.949c0 4.418-3.582 8.001-8 8.001h-36.149v20.351h31.174c4.418 0 7.999 3.583 7.999 8.001s-3.581 8.001-7.999 8.001h-31.174v27.105c0 4.418-3.582 7.996-8 7.996s-8-3.578-8-7.996v-71.46c0-4.418 3.582-8.001 8-8.001h44.149c4.418 0 8 3.584 8 8.001zm-114.623 63.459h-16.935v-55.458h16.935c15.29 0 27.731 12.438 27.731 27.729s-12.441 27.729-27.731 27.729zm0-71.46h-24.934c-4.42 0-8.001 3.584-8.001 8.001v71.46c0 4.418 3.582 7.996 8.001 7.996h24.934c24.114 0 43.729-19.615 43.729-43.726s-19.616-43.731-43.729-43.731zm-71.781 42.038h-22.381v-26.035h22.381c7.177 0 13.017 5.836 13.017 13.017s-5.841 13.018-13.017 13.018zm0-42.038h-30.38c-4.419 0-8.001 3.584-8.001 8.001v71.46c0 4.418 3.582 7.996 8.001 7.996s8-3.578 8-7.996v-21.421h22.381c15.999 0 29.017-13.018 29.017-29.02s-13.017-29.02-29.017-29.02z",
    fill: "#edeff3",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.e94cda3b127e3920d2f0401d783b892c.svg";
export { ForwardRef as ReactComponent };